import Head from "next/head";
import { wrapper } from "@/redux/Store";

import LiveClassPolicy from "@/containers/StaticPages/LiveClassPolicy";
import { renderMetaData } from "@/utils";
const LiveClassPolicyPage = () => {
  const metaData = {
    title: "Shyft privacy policy",
    description: "Shyft privacy policy",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <LiveClassPolicy />
      </main>
    </>
  );
};

export default LiveClassPolicyPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
